import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

interface Props {
  phoneNumber: string
  date: string
}

export function UnsubscribeDataSms(props: Props) {
  const { date, phoneNumber } = props
  const texts = useTexts()

  return (
    <Alert severity="info">
      <AlertTitle>{texts.unsubscribeSmsTitle}</AlertTitle>
      {texts.unsubscribeSmsDescription(phoneNumber, date)}
    </Alert>
  )
}
